<template>
  <div class="card acordeao-categoria mb-3">
    <!-- cabeçalho colapsável -->
    <button type="button" class="acordeao-cabecalho" @click="aberto = !aberto">
      <span class="font-weight-bold">{{ categoria.nome }}</span>
      <span class="acordeao-cabecalho__direita">
        <span class="badge-contagem" :class="{ 'badge-contagem--zero': contagemAtivos === 0 }">
          {{ contagemAtivos }} {{ contagemAtivos === 1 ? 'ativo' : 'ativos' }}
        </span>
        <i class="acordeao-chevron" :class="aberto ? 'chevron-cima' : 'chevron-baixo'"></i>
      </span>
    </button>

    <div v-show="aberto" class="acordeao-corpo p-3">
      <!-- placeholder de categoria futura (ex.: API) -->
      <p v-if="categoria.placeholder" class="text-muted mb-0">{{ categoria.placeholder }}</p>

      <template v-else>
        <!-- produtos da categoria; a config de grupo (hoje, exclusiva do Resumo IA) aparece logo
             abaixo do produto que a consome (produto.usaTokenGrupo), não no topo da categoria -->
        <template v-for="produto in categoria.produtos">
          <LinhaProduto
            :key="produto.slug"
            :produto="produto"
            :item="itemDoProduto(produto.slug)"
            :erros="erros[produto.slug] || {}"
            :disabled="disabled"
            @toggle="$emit('toggle-produto', { slug: produto.slug, ativo: $event })"
            @campo-input="emitirCampo(produto.slug, $event)"
          />
          <div
            v-if="produto.usaTokenGrupo && grupoAtivo"
            :key="produto.slug + '-grupo'"
            class="alert-grupo mb-3"
          >
            <p class="mb-2 text-success">
              {{ categoria.grupo.descricao }}
            </p>
            <CamposIntegracaoDinamicos
              :campos="categoria.grupo.campos"
              :valor="valorGrupo"
              :erros="errosGrupo"
              :disabled="disabled"
              @campo-input="emitirCampo(grupoChave, $event)"
            />
            <div class="form-group mb-0">
              <label :for="idObsGrupo">Observações</label>
              <textarea
                :id="idObsGrupo"
                class="form-control"
                rows="2"
                placeholder="Observações administrativas (opcional)"
                :disabled="disabled"
                :value="valorGrupo.observacoes"
                @input="emitirCampo(grupoChave, { campoChave: 'observacoes', valor: $event.target.value })"
              ></textarea>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import LinhaProduto from './LinhaProduto.vue'
import CamposIntegracaoDinamicos from './CamposIntegracaoDinamicos.vue'

const ITEM_VAZIO = { ativo: false, valor: {} }

export default {
  name: 'AcordeaoCategoriaProduto',
  components: { LinhaProduto, CamposIntegracaoDinamicos },
  props: {
    categoria: { type: Object, required: true },
    valores: { type: Object, default: () => ({}) },
    erros: { type: Object, default: () => ({}) },
    contagemAtivos: { type: Number, default: 0 },
    grupoChave: { type: String, default: null },
    grupoAtivo: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return { aberto: false }
  },
  computed: {
    idObsGrupo () { return 'obs-grupo-' + this.categoria.id },
    valorGrupo () {
      const item = this.grupoChave && this.valores[this.grupoChave]
      return (item && item.valor) || {}
    },
    errosGrupo () {
      return (this.grupoChave && this.erros[this.grupoChave]) || {}
    }
  },
  methods: {
    itemDoProduto (slug) {
      return this.valores[slug] || ITEM_VAZIO
    },
    emitirCampo (chave, { campoChave, valor }) {
      this.$emit('campo-input', { chave, campoChave, valor })
    }
  }
}
</script>

<style scoped>
.acordeao-cabecalho {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: #f7f9fc;
  border: none;
  border-radius: 0.5rem;
  text-align: left;
}
.acordeao-cabecalho__direita { display: flex; align-items: center; gap: 0.75rem; }
.badge-contagem {
  background: #eaf1fe; color: #2f80ed;
  padding: 0.25rem 0.6rem; border-radius: 1rem; font-size: 0.8rem;
}
.badge-contagem--zero { background: #eef1f5; color: #8a94a6; }
.acordeao-chevron { border: solid #8a94a6; border-width: 0 2px 2px 0; padding: 3px; display: inline-block; }
.chevron-baixo { transform: rotate(45deg); }
.chevron-cima { transform: rotate(-135deg); }
.alert-grupo { border: 1px solid #cfe9d6; background: #f3fbf5; border-radius: 0.5rem; padding: 0.75rem 1rem; }
</style>
